"use strict";

import Vue from "vue";
import axios from "axios";
import config from './../config';

let axiosConfig = {
  baseURL: config.apiBaseUrl
};

const _axios = axios.create(axiosConfig);

_axios.interceptors.request.use(
  function (config) {
    config.baseURL = config.apiBaseUrl
    config.headers['Authorization'] = `Bearer ${Vue.prototype.$auth.token}`
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    // Do something with response error
    return Promise.reject(error);
  }
);

Plugin.install = function (Vue) {
  Vue.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    }
  });
};

Vue.use(Plugin);

export default Plugin;
